import { color, media, radius, spacing, typography } from '@gyym/ui'
import styled from 'styled-components'

export const Container = styled.div`
  max-width: 530px;
  margin: 0 auto;
  padding: 0 ${spacing(8)};

  ${media.pc} {
    padding: 0;
  }
`

export const Heading = styled.h3`
  ${typography('subhead1')};
  display: flex;
  align-items: center;
`

export const Content = styled.p`
  ${typography('body1')};
  margin-top: ${spacing(2)};
`

export const ImageWrapper = styled.div`
  min-width: 80px;
  margin-left: ${spacing(4)};
`

export const Item = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: ${spacing(6)};
`

export const Precaution = styled.span`
  ${typography('body2')};
  color: ${color('gray.02')};
`

export const Covid = styled.div`
  ${typography('body2')};
  color: ${color('gray.02')};
  margin-top: ${spacing(8)};
`

export const List = styled.ol`
  counter-reset: step-counter;

  ${Heading} {
    &::before {
      counter-increment: step-counter;
      content: counter(step-counter);
      ${typography('subhead1')};
      color: ${color('white')};
      border-radius: ${radius('full')};
      background: ${color('gradient.primary')};
      display: flex;
      align-items: center;
      justify-content: center;
      width: 26px;
      height: 26px;
      margin-right: ${spacing(2)};
    }
  }
`
